import React, { useState, useEffect } from 'react';
import getExpertUserList from '../../../services/expertuser';
import Table from 'react-bootstrap/Table';
import UserSupportTable from './UserSupportTable';
import CreateTicket from './CreateTicket';
import { Link } from 'react-router-dom';
import SupportEmailLine from '../../Support/SupportEmailLine';


function UserSupport() {
    const [showCreateTicket, setShowCreateTicket] = useState(false);
    const userType = localStorage.getItem('userType');
    const [recall, setRecall] = useState(0)
    // Counselors open tickets to Vertivio support (they had no button before); their clients'
    // tickets still come to them and are listed separately.
    const isCounselor = userType === 'E';
    const recipientNote = userType === 'EU'
        ? 'Your counselor receives this. Vertivio support gets a copy, so billing and account questions reach us too.'
        : 'This goes to Vertivio support.';
    const handleshowCreateTicket =() =>{
        setShowCreateTicket(!showCreateTicket)
    }
    return (
        <>
            <div className='d-flex flex-stack'>
                <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6 " >
                    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3 ">
                        <h1 class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                        Support
                        </h1>
                        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li class="breadcrumb-item text-muted">
                                <Link to="/" class="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li class="breadcrumb-item">
                                <span class="bullet bg-gray-500 w-5px h-2px"></span>
                            </li>
                            <li class="breadcrumb-item text-muted">Support</li>
                        </ul>
                    </div>
                </div>
                {userType==='U' || userType==='EU' || userType==='E' ? <div class="d-flex align-items-center gap-2 gap-lg-3" onClick={handleshowCreateTicket}>
                    <a class="btn btn-sm fw-bold btn-primary">{isCounselor ? 'Contact Vertivio support' : 'Create Ticket'}</a>
                </div> : null}
                </div>
            <SupportEmailLine className="fs-6 text-gray-700 mb-5" />
            <CreateTicket show={showCreateTicket} handleClose={handleshowCreateTicket} recallAPI={() => setRecall((count) => count + 1)}
                title={isCounselor ? 'Contact Vertivio support' : 'Create Ticket'}
                recipientNote={recipientNote} />
            <div className="mb-80">
                {isCounselor ? <>
                    <UserSupportTable recall={recall} title="Requests from your clients" />
                    <div className="mt-10">
                        <UserSupportTable recall={recall} own={true} title="Your requests to Vertivio support" />
                    </div>
                </> : <UserSupportTable recall={recall}/>}
            </div>
        </>
    )
}
export default UserSupport;